<template>
	<div class="t-page_profile t-work-area">
		<h1>{{ pageText.title }}</h1>
		<cmp-tabs :data="[{title: tabs.tab_1, url: 'profileInfo'},{title: tabs.tab_2, url: 'my_courses'},{title: tabs.tab_3, url: 'my_entries'},{title: tabs.tab_5, url: 'my_info'},{title: tabs.tab_6, url: 'settings'}]"
                @Loading="Loading($event)"></cmp-tabs>

        <div class="t-profile-content">
            <transition name="fade">
                <cmp-preload v-if="loading"></cmp-preload>
            </transition>
            <transition name="profile-view">
                <router-view></router-view>
            </transition>
        </div>

	</div>
</template>

<script>
    let tabsText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/profileTabs.json' : 'staticText',
        tabs: {
            tab_1: "Стартовая",
            tab_2: "Я учу",
            tab_3: "Я учусь",
            tab_4: "Документы",
            tab_5: "Мои данные",
            tab_6: "Настройки",
            //tab_7: "Черный список",
        }
    };
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/profilePageIndex.json' : 'staticText',
        main: {
            title: "Личный кабинет"
        }
    };

    import {store} from '../../store'
    import {mapActions} from 'vuex';

    import {mapGetters} from 'vuex';
		import Tabs from '../../vue_components/Tabs.vue'

    import Preload from '../../vue_components/Preload.vue'

		export default {
		    data(){
		        return {
                    tabs: {},
                    pageText: {},
                    loading: false
                }
				},
				components: {
                    'cmp-tabs': Tabs,
                    'cmp-preload': Preload
				},
				methods: {
                    ...mapActions(['UpdatePreloadState']),
                    Load(pageText, tabs){
                        this.pageText = pageText;
                        this.tabs = tabs;
                        setTimeout(() => {
                            this.UpdatePreloadState(false);
                        }, 500)
                    },
                    Loading(e){
                        this.loading = e
                    }
				},
            beforeRouteEnter (to, from, next) {
                let count = 0;

                let pageText = {},
                    tabs = {};

                store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                    pageText = data;

                    count++;
                    RunNext();
                });

                store.dispatch('staticText/LoadTabsText', tabsText).then((data) => {
                    tabs = data;
                    count++;
                    RunNext();
                });

                store.dispatch('staticText/LoadLessonText').then(() => {
                    count++;
                    RunNext();
                });

                store.dispatch('handbook/LoadBannerType').then(() => {
                    count++;
                    RunNext();
                });

                let RunNext = () => {
                    if(count > 3)
                        next(vm => vm.Load(pageText, tabs))
                }
            },
            beforeRouteLeave(to, from, next) {
                this.UpdatePreloadState(true);
                next();
            },
		}
</script>

<style lang="sass">
.t-profile-content
    position: relative
.profile-view-enter-active, .profile-view-leave-active 
    transition: opacity .5s

.profile-view-enter, .profile-view-leave-to 
    opacity: 0

.t-schedule
	.t-work-area__cell
        margin-bottom: 32px

.t-page_profile
	.t-courses__arrows
		top: 23px
@media(max-width: 769px)
	.t-schedule
		.t-work-area__cell
            margin-bottom: 0
            background: transparent
            box-shadow: unset
            border-radius: 0
            padding: 0
		> h2
			padding: 0 16px
			font-size: 20px
			&:not(:first-child)
				margin-top: 32px
		.t-calendar
			margin: 0 auto

</style>


// WEBPACK FOOTER //
// src/vue_pages/Profile/Index.vue